import { authenticatedFetchJson } from '../api/apiClient'
import { apiEndpoints } from '../../consts'

// Single source of truth for GET /api/billing/dashboard-stats. The Sidebar
// draft badge, the billing page draft badge, and the billing Dashboard KPIs
// all read this endpoint; without sharing they each fire their own request on
// a /billing load. A short-lived cache collapses consumers that mount together
// into ONE network call, while still refetching on later navigations.
const TTL_MS = 5000

let cached = null // { data, at }
let inFlight = null

/**
 * Fetch the billing dashboard stats, served from a short-lived shared cache.
 * @param {Object} [opts]
 * @param {boolean} [opts.force] - Bypass the cache and fetch fresh
 * @returns {Promise<Object|null>} The stats payload (response.data), or null
 */
export const fetchBillingDashboardStats = ({ force = false } = {}) => {
  if (force) cached = null

  if (cached && (Date.now() - cached.at) < TTL_MS) {
    return Promise.resolve(cached.data)
  }

  if (!inFlight) {
    inFlight = authenticatedFetchJson(apiEndpoints.billingDashboardStats)
      .then((res) => {
        const data = res?.data ?? null
        cached = { data, at: Date.now() }
        return data
      })
      .finally(() => { inFlight = null })
  }

  return inFlight
}

/** Clear the cache and any in-flight request (used after mutations and in tests). */
export const invalidateBillingDashboardStats = () => {
  cached = null
  inFlight = null
}
